// removed by extract-text-webpack-plugin
module.exports = {"lieferschein":"lieferschein__1G5K5","name":"name__KtJ_Y","date":"date__2qSDC","dlButton":"dlButton__3xV0z"};